module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "popover-checkmark-btn"
  }, [_c('svg-icon', {
    attrs: {
      "width": "16px",
      "height": "16px",
      "icon": _vm.Check
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1025c354"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/popover/PopoverCheckmarkBtn.vue
// module id = 1810
// module chunks = 0